// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"f5d2690b","169":"0af25801","532":"e48688ad","633":"78159172","672":"05ced90d","796":"cca36952","922":"e4dfe5fb"}[chunkId] + ".css";
};